import { alpha, useTheme, Box, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Grayscale = ({ onGrayscale, grayscale, mapsView, ...props }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Tooltip
      arrow
      placement="left"
      title={t(
        `cartography.maps.controls.${
          grayscale ? 'grayscale_on' : 'grayscale_off'
        }`,
      )}
    >
      <Box
        sx={{
          color: '#464646',
          cursor: 'pointer',
          backgroundColor: 'white',
          minHeight: '40px',
          minWidth: '40px',
          maxHeight: '40px',
          maxWidth: '40px',
          borderRadius: mapsView === 'building' ? '50%' : '8px',
          border: 'solid 1px',
          borderColor: 'border.primary',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: `0 12px 16px -8px ${alpha(
            theme.palette.common.black,
            0.24,
          )}`,
          '&:hover': {
            color: theme.palette.primary.main,
          },
        }}
        onClick={onGrayscale}
      >
        <i className="fa-regular fa-paintbrush-fine"></i>
      </Box>
    </Tooltip>
  )
}

export default Grayscale